var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showButton)?_c('button',{staticClass:"play-button",on:{"click":_vm.play}},[_vm._v("Começar")]):_vm._e()]),_vm._v(" "),_c('lottie',{attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab337e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroView.vue
// module id = null
// module chunks = 